export default "__VITE_ASSET__D1I4wcDV__"